<ng-container *ngIf="type !== 'checkbox' && type !== 'select'">
    <div class="label" (click)="clickInfoEmit()" *ngIf="label" [ngStyle]="{color: error ? errorColor : labelColor}">
        {{label}} <div *ngIf="info" class="info" [ngStyle]="{ color: linkColor }">
            <div>{{info}} </div><img [src]="theme.input.infoImg" alt="" />
        </div>
    </div>

    <span *ngIf="type === 'password'" class="icon-view" [ngClass]="isPassword ? 'icon-show': 'icon-hide'"
        (click)="toggleShowPass()" [ngStyle]="{backgroundColor: linkColor}"></span>

    <input [formControl]=" control" #native [id]="id" [type]="type" [placeholder]="placeholder" [disabled]="disabled"
        [ngStyle]="{backgroundColor: bgColor, border: error ? '1px solid ' + errorColor : 'none', borderRadius: radius}"
        *ngIf="type !== 'password'" [max]="actualDate" [attr.maxlength]="maxLength"/>
    <input [formControl]="control" #native [id]="id" [type]="type" [attr.type]="isPassword ? 'password' : 'text'"
        [placeholder]="placeholder" [disabled]="disabled"
        [ngStyle]="{backgroundColor: bgColor, border: error ? '1px solid ' + errorColor : 'none', borderRadius: radius}"
        *ngIf="type === 'password'" [attr.maxlength]="maxLength" />
    <!-- <img [src]="theme.qr.img" (click)="handle(action, action.isStart ? 'stop' : 'start')" *ngIf="qr"> -->
    <img [src]="theme.datepicker.img" *ngIf="type === 'date'" class="today" (click)="openDatepicker()">

    <span class="error-msg" *ngIf="error" [ngStyle]="{ color: errorColor }"> {{errorMsg}}
    </span>

    <div class="qr_wrapper" *ngIf="qr" [ngStyle]="{display: !started? 'none': 'block'}">
        <ngx-scanner-qrcode #action="scanner" [config]="config" (event)="onEvent($event, action)">
        </ngx-scanner-qrcode>
        <button (click)="closeModal(action)" class="btnClose">cerrar</button>
    </div>
</ng-container>

<ng-container *ngIf="type === 'select'">
    <div class="label" (click)="clickInfoEmit()" *ngIf="label" [ngStyle]="{color: error ? errorColor : labelColor}">
        {{label}} <div *ngIf="info" class="info" [ngStyle]="{ color: linkColor }">
            <div>{{info}} </div><img [src]="theme.input.infoImg" alt="" />
        </div>
    </div>

    <select [formControl]="control" #native [id]="id" [disabled]="disabled"
        [ngStyle]="{backgroundColor: bgColor, border: error ? '1px solid ' + errorColor : 'none', borderRadius: radius}">
        <option value="">{{'register.form.gender.placeholder' | translate}}</option>
        <option *ngFor="let item of listItems" [value]="item.value" [disabled]="item.value === null" style="color: black;">{{item.key}}</option>
    </select>
    <span class="error-msg" *ngIf="error" [ngStyle]="{ color: errorColor }"> {{errorMsg}}</span>
</ng-container>

<div class="check" *ngIf="type === 'checkbox'">
    <div class="label" (click)="clickInfoEmit()" *ngIf="label" [ngStyle]="{color: error ? errorColor : labelColor}">
        {{label}}</div>

    <input [formControl]="control" #native hidden [id]="id" [type]="type" [placeholder]="placeholder"
        [checked]="checked" [value]="checkboxValue"
        [ngStyle]="{backgroundColor: bgColor, border: error ? '1px solid ' + errorColor : 'none', borderRadius: radius}" />
    <div class="switch" (click)="checkboxClicked()"
        [ngStyle]="{background: checked ? theme.checkbox.checkedBgColor : theme.checkbox.bgColor,
        opacity: control.disabled ? 0.5 : 1,
        cursor: control.disabled ? 'not-allowed' : 'pointer' }"></div>
</div>
